import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends RestfulService<Models.Notification> {

  constructor(public restService: RestService) {
    super(Models.Notification);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('notifications');
  }
}
